export default {
    getMainPopupList(state) {
        return state.mainPopupList;
    },
};